export default __webpack_public_path__ + "static/media/dz.1759a182.svg";